import type { FunctionComponent } from 'react';

import type { OptionComponentProps } from './types';

const Option: FunctionComponent<OptionComponentProps> = ({
  creatorValue = '',
  creatorAction = '',
  option = {},
  isCreatorValue = false,
}) => (
  <>
    {isCreatorValue || option.value === creatorValue
      ? `${creatorAction} "${option.label}"`
      : option.label}
  </>
);

export default Option;
